'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { fieldGroupDropTarget } from 'DesignEditorsUI/components/customWidgetEditor/sidebar/main/fieldsTable/FieldsTableRowDragDrop';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.fields.fieldGroupDropZone.${key}`;

class FieldGroupDropZone extends Component {
  render() {
    const {
      connectDropTarget,
      isOver,
      canDrop
    } = this.props;
    const className = classNames("field-group-drop-zone p-all-4 text-center", isOver && 'is--over' + (!canDrop ? " is--cannot-drop" : ""));
    return connectDropTarget( /*#__PURE__*/_jsx("div", {
      className: className,
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('message')
        })
      })
    }));
  }

}

FieldGroupDropZone.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired
};
export default fieldGroupDropTarget(FieldGroupDropZone);